import { render, staticRenderFns } from "./ProductOrdersPending.vue?vue&type=template&id=12b2c810"
import script from "./ProductOrdersPending.vue?vue&type=script&lang=ts"
export * from "./ProductOrdersPending.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports